import React from "react";

export default function InputTwitterUrl({ errors, register }) {
  return (
    <input
      className={`form-control ${errors.twitter_url && "is-invalid"}`}
      type="text"
      placeholder="https://twitter.com/usuario"
      name="twitter_url"
      {...register("twitter_url", {
        pattern: {
          value:
            /^https:\/\/(www\.)?(twitter\.com|x\.com)\/[a-zA-Z0-9._-]+\/?$/,
          message:
            "La URL debe comenzar con https://twitter.com/ y contener un usuario",
        },
      })}
    />
  );
}
